/**
 * Dialog helpers and utilities
 */

import Vue from 'vue';

export interface DialogInstance {
  close(): void;
  loading(val: boolean): void;
}

/**
 * Shows a request limit error modal dialog
 * @param vm - Vue component instance (to access $dialog, $t and t methods)
 * @param onMyRequests - callback when "My requests" button is clicked
 * @param onCancel - optional callback when cancel/close button is clicked
 * @param cancelButtonText - optional text for the cancel button (defaults to 'global.cancel')
 */
export function showRequestLimitErrorModal(
  vm: Vue,
  onMyRequests: () => void,
  onCancel?: () => void,
  cancelButtonText?: string
): DialogInstance {
  const dialog = vm.$dialog({
    content: vm.$t('page.active_conversation.over_limit_active_error') as string,
    buttons: [
      {
        class: 'primary',
        name: vm.t('global.my_requests'),
        callback: () => {
          dialog.close();
          onMyRequests();
        },
      },
      {
        name: cancelButtonText ?? vm.t('global.cancel'),
        callback: () => {
          dialog.close();
          onCancel?.();
        },
      },
    ],
  });

  return dialog;
}
